import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { deleteViolationFailed, deleteViolationSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { NO_CONTENT } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* deleteViolation(action) {
  try {
    const url = `${BACKEND_URL}/violations/${action.payload}`;
    const dataResponse = yield makeRequest(url, {}, action, 'DELETE', true);
    if (dataResponse.status === NO_CONTENT) {
      yield put(deleteViolationSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      yield put(deleteViolationFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(deleteViolationFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
